// eslint-disable-next-line unicorn/prefer-module
module.exports = (request) => {
  const {
    headers: { 'x-forwarded-proto': protocol = request.protocol } = {},
  } = request;

  return protocol;
};
